module.exports = __webpack_public_path__ + "tag-operation-white.svg?e5d41b642c0e25b9fb0eeb361ea4cd82";